import { render } from "./HomeTab.vue?vue&type=template&id=68a78124"
const script = {}

import "./HomeTab.vue?vue&type=style&index=0&id=68a78124&lang=scss"

import exportComponent from "/opt/build/repo/access-trucks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__